import { shallowEqual, useSelector } from 'react-redux';

export const useAccountRaceStatistic = () => ({
  quests: useSelector((state: any) => state.accounts.getIn(['statistics', 'quest']), shallowEqual),
});
